export default {
  namespaced  : true,

  state       : {
    isOpen                  : false,
    contentType             : 'connection',

    isOpenConnectionEditor  : false,
    isOpenParkBoardEditor   : false,

    // Connection用のメタ情報です。
    podRoomId               : null,
    replyPodMessageId       : null,
  },

  mutations   : {
    setIsOpen(state, value){
      state.isOpen = value;
    },

    setContentType(state, value){
      state.contentType = value;
    },

    setIsOpenConnectionEditor(state, value){
      state.isOpenConnectionEditor = value;
    },

    setIsOpenParkBoardEditor(state, value){
      state.isOpenParkBoardEditor = value;
    },

    setConnectionMeta(state, data){
      if(typeof data.podRoomId !== 'undefined'){
        state.podRoomId = data.podRoomId;
      }

      if(typeof data.replyPodMessageId !== 'undefined'){
        state.replyPodMessageId = data.replyPodMessageId;
      }
    },

    resetStore(state){
      state.detailModal.isOpen                    = false;
      state.detailModal.characterId               = null;
      state.detailModal.immmediateryOpenAddModal  = false;
    }
  },

  actions     : {
    updateCreateButton(context, payload){
      if(typeof payload.isOpen !== 'undefined'){
        context.commit('setIsOpen', payload.isOpen);
      }

      if(typeof payload.contentType !== 'undefined'){
        context.commit('setContentType', payload.contentType);
      }
    },

    updateOpenEditor(context, payload){
      // もし開く処理を行う場合は今開いているEditorを全て閉じます。
      if(payload.value === true){
        context.commit('setIsOpenConnectionEditor', false);
        context.commit('setIsOpenParkBoardEditor',  false);
      }

      switch(payload.editorType){
        case 'connection':
          context.commit('setIsOpenConnectionEditor', payload.value);

          // connection用のメタデータが存在する場合は処理します。
          if(typeof payload.connection !== 'undefined'){
            context.commit('setConnectionMeta', payload.connection);
          }
        break;

        case 'park':
          context.commit('setIsOpenParkBoardEditor', payload.value);
        break;
      }
    },
    
    resetStore(context){
      context.commit('resetStore');
    }
  }
}